var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1111 6.72217H20.1404C20.5877 6.72217 20.8113 6.72217 20.9421 6.81621C21.0562 6.89826 21.1306 7.02456 21.1469 7.16416C21.1655 7.32417 21.0569 7.51967 20.8397 7.91068L19.3702 10.5559C19.2914 10.6977 19.252 10.7686 19.2365 10.8437C19.2229 10.9101 19.2229 10.9787 19.2365 11.0451C19.252 11.1202 19.2914 11.1911 19.3702 11.3329L20.8397 13.9781C21.0569 14.3691 21.1655 14.5646 21.1469 14.7246C21.1306 14.8642 21.0562 14.9905 20.9421 15.0726C20.8113 15.1666 20.5877 15.1666 20.1404 15.1666H12.5444C11.9844 15.1666 11.7044 15.1666 11.4904 15.0576C11.3023 14.9617 11.1493 14.8088 11.0534 14.6206C10.9444 14.4067 10.9444 14.1267 10.9444 13.5666V10.9444M7.25 21.5002L3.02778 4.61133M4.61115 10.9444H12.5111C13.0712 10.9444 13.3512 10.9444 13.5651 10.8355C13.7533 10.7396 13.9062 10.5866 14.0021 10.3984C14.1111 10.1845 14.1111 9.9045 14.1111 9.34445V4.1C14.1111 3.53995 14.1111 3.25992 14.0021 3.04601C13.9062 2.85785 13.7533 2.70487 13.5651 2.60899C13.3512 2.5 13.0712 2.5 12.5111 2.5H4.54922C3.8507 2.5 3.50144 2.5 3.26256 2.64474C3.05319 2.77159 2.89762 2.97084 2.82534 3.20472C2.74286 3.47158 2.82757 3.81041 2.997 4.48807L4.61115 10.9444Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag05);
export default __webpack_public_path__ + "static/media/flag-05.ef79e301ad7bcbe592d255a8ee6aefb7.svg";
export { ForwardRef as ReactComponent };